var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-container"},[(_vm.currentNotification)?_c('Notification',{key:_vm.currentNotification.uid,attrs:{"notification":_vm.currentNotification,"type":_vm.currentNotification.type,"duration":10000},on:{"close":_vm.handleNotificationClose}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }